import { configureStore } from "@reduxjs/toolkit";
import { getDefaultMiddleware } from "@reduxjs/toolkit";
import authSlice from "./auth/slice";
import accountsSlice from "./accounts/slice";
import staffsSlice from "./staffs/slice";
import addressSlice from "./address/slice";
import masterSettingSlice from "./masterSetting/slice";
import companiesSlice from "./companies/slice";
import fileDataSlice from "./folder&documents/slice";
import OrganisationSlice from "./organisation/slice";
import customerSlice from "./customer/slice";
import ticketSlice from "./ticket/slice";
import chatSlice from "./chat/slice";
import broadcastsSlice from "./broadcast/slice";
import notificationsSlice from "./notifications/slice";
import activityLogSlice from "./activityLog/slice";
import serviceRequestSlice from "./serviceRequest/slice";
import salesSlice from "./sales/slice";
import reportSlice from "./report/slice";
import dashboardSlice from "./dashboard/slice";
import uploadFileSlice from "./uploadFile/slice";

const rootReducer = {
  authData: authSlice,
  addressData: addressSlice,
  accountsData: accountsSlice,
  staffsData: staffsSlice,
  customerData: customerSlice,
  masterSettingData: masterSettingSlice,
  companiesData: companiesSlice,
  fileData: fileDataSlice,
  OrganisationData: OrganisationSlice,
  ticketData: ticketSlice,
  chatData: chatSlice,
  broadcastsData: broadcastsSlice,
  notificationsData: notificationsSlice,
  activityLogData: activityLogSlice,
  serviceRequestData: serviceRequestSlice,
  salesData: salesSlice,
  reportData: reportSlice,
  dashboardData: dashboardSlice,
  uploadFileData: uploadFileSlice,
};

const customizedMiddleware = getDefaultMiddleware({
  serializableCheck: false,
});

const store = configureStore({
  reducer: rootReducer,
  middleware: customizedMiddleware,
});

export default store;
